<template>
  <v-row justify="center">
      <v-dialog v-model="visible" persistent max-width="380" @keydown.esc="confirmCancel">
        <v-card class="pb-5 pt-3">
          <v-img
              src="assets/img/logo.png"
              width="54"
              class="mx-auto mt-3"
            />
          <v-card-title class="pt-3 font-weight-medium">{{message}}</v-card-title>

          <div class="text-center mt-5">
            <v-btn class="body-1 px-7" depressed small rounded color="primary" @click="confirmOk">Oui</v-btn>
            <v-btn class="body-1 mr-0 px-7 black--text" depressed small rounded color="#E1E1E1" @click="confirmCancel">Non</v-btn>
          </div>
        </v-card>
      </v-dialog>
  </v-row>
</template>

<script>
  import { CONFIRM_OK, CONFIRM_CANCEL } from '@/store/mutation-types.js';
  import { mapState, mapMutations } from 'vuex';
  export default {
    name: "AppConfirm",
    data: () => ({
      dialog: true
    }),
    computed: {
      ...mapState({
        visible: (state) => state.confirm.visible,
        message: (state) => state.confirm.message
      })
    },
    methods: {
      ...mapMutations([
          CONFIRM_OK,
          CONFIRM_CANCEL
      ]),
    }
  }
</script>

<style scoped>

</style>
